// Generated by tools/generate-platform-license.mjs.
// Generated from tools/contracts/platform-license.cts. Do not edit directly.








// New authorizations only. Historical orders retain their immutable snapshots.
const LICENSE_VERSION = 'mira-scope-2026-001';
const LICENSE_TAGS = ['现代','商务','时尚','御姐','可爱','甜美','高冷','邻家','灵动','知性','优雅','英气','阳光','亲和','少年感','职场精英','都市丽人','霸道总裁','霸道女总裁','阳光少年','元气少女','古装美人','二次元','硬汉','成熟大叔'];
const LICENSE_PACKAGES = [
  { id: 'platform_drama', name: '影视剧', priceFen: 50000, quantity: 1, months: 6, summary: '单部作品 · 6个月' },
  { id: 'platform_ecom', name: '电商信息流', priceFen: 50000, quantity: 15, months: 1, summary: '15条内容 · 1个月' },
  { id: 'platform_tvc', name: 'TVC', priceFen: 100000, quantity: 1, months: 12, summary: '单条成片 · 1年' },
];
const LICENSE_SCOPES = {
  ecommerce: ['美妆个护','护肤彩妆','食品饮料','零食烘焙','酒水饮品','服饰鞋包','内衣配饰','珠宝腕表','3C数码','家用电器','运动户外','宠物用品','香水香氛','家居家纺','文创潮玩'],
  film: ['都市情感','职场商战','家庭伦理','古装宫廷','古装仙侠','悬疑推理','刑侦破案','科幻','玄幻修仙','喜剧','甜宠','动作','青春校园','人物传记','历史正剧'],
};
const LICENSE_PROHIBITED = {
  ecommerce: ['医疗功效宣称','烟草制品（含电子烟）','处方药','母乳替代食品','投资理财','虚假促销','医疗器械、保健食品','成人用品','争议社会议题','保健疗效','医疗美容'],
  film: ['危害国家安全','恐怖主义、极端主义','民族仇恨歧视','暴力淫秽色情','虚假有害信息','政治军事外交','色情低俗','血腥暴力','政治敏感','宗教民族敏感','未成年人不良','丑化恶搞','吸烟酗酒劝诱','涉毒涉枪','歧视仇恨','侵犯人格权','反派角色形象','死亡戏/重伤戏','情感亲密戏','性感着装','吸烟/饮酒镜头'],
};
const LICENSE_RULES = [
  '仅许可在订单明确的单一项目内，以既有模型生成、合成人像相关内容；不转让肖像权或原始素材的通用使用权，不包含真人拍摄、出席或直播服务。',
  '禁止模型训练、微调、LoRA、训练数据集、算法测试、人脸识别和身份验证。作为既有模型参考输入时，也不得允许工具提供方训练或收录素材。',
  '未勾选的品类或题材不授权。固定禁止事项不提供勾选或调整入口，适用于全部授权类型。',
  '同一项目使用多种授权类型须分别购买。续作、番外、衍生作品、更换商品或营销主题、独立投放周期均须另行申请。',
  '电商信息流限15条内容及1个月，剪辑、裁切与不同比例版本计入该数量限制。',
  '具有品牌、产品或服务营销目的的成片按TVC申请，不因采用短剧情节、无口播或无购买链接改选影视剧。TVC长短版属于同一成片。',
  '付款后须由授权方确认，合同生效及可领取状态以订单记录为准。期满继续使用须另行取得授权。范围变更仅适用于双方确认后的新授权，不回写历史订单。',
];
function list(value         , options          , label        , min = 0)           {
  if (!Array.isArray(value) || value.length < min || value.length > options.length || new Set(value).size !== value.length || value.some(item => !options.includes(item))) throw new Error(`${label}请选择有效选项`);
  return options.filter(item => value.includes(item));
}
function normalizeLicense(value              ) {
  if (!value || typeof value !== 'object' || Array.isArray(value) || value.version !== LICENSE_VERSION
    || Object.keys(value).some(key => !['version','packages','ecommerce','film'].includes(key))) throw new Error('请确认当前授权范围说明');
  const packages = list(value.packages, LICENSE_PACKAGES.map(item => item.id), '授权套餐', 1);
  const ecommerce = list(value.ecommerce, LICENSE_SCOPES.ecommerce, '电商范围');
  const film = list(value.film, LICENSE_SCOPES.film, '影视范围');
  if ((packages.includes('platform_drama') && !film.length) || (packages.some(id => id !== 'platform_drama') && !ecommerce.length)) throw new Error('请选择所同意套餐的可授权范围');
  return { version: LICENSE_VERSION, packages, ecommerce, film };
}
function normalizeLicenseProfile(value                     ) {
  const license = normalizeLicense(value.license);
  const tags = list(value.tags, LICENSE_TAGS, '形象标签', 5);
  if (tags.length > 10) throw new Error('形象标签请选择5–10项');
  const height = value.height === undefined || value.height === '' ? undefined : value.height;
  if (height !== undefined && (typeof height !== 'number' || !Number.isFinite(height) || height < 50 || height > 250)) throw new Error('身高请填写50–250厘米');
  const socialLinks                         = {};
  if (value.socialLinks !== undefined && (!value.socialLinks || typeof value.socialLinks !== 'object' || Array.isArray(value.socialLinks) || Object.keys(value.socialLinks).some(key => !['douyin','xiaohongshu'].includes(key)))) throw new Error('社交媒体资料无效');
  for (const [key, host] of [['douyin','douyin.com'],['xiaohongshu','xiaohongshu.com']]) {
    const raw = value.socialLinks && value.socialLinks[key];
    if (raw === undefined || raw === '') continue;
    let url;
    try { url = new URL(raw          ); } catch { throw new Error('请填写有效的社媒个人主页链接'); }
    if (typeof raw !== 'string' || raw.length > 500 || url.protocol !== 'https:' || url.username || url.password || url.port
      || ![host, `www.${host}`].includes(url.hostname) || !(key === 'douyin' ? /^\/user\/[^/]+\/?$/ : /^\/user\/profile\/[^/]+\/?$/).test(url.pathname)) throw new Error('请填写抖音或小红书的HTTPS个人主页链接');
    url.search = ''; url.hash = ''; socialLinks[key] = url.href;
  }
  return { license, tags, socialLinks, ...(height === undefined ? {} : { height }) };
}
export { LICENSE_VERSION, LICENSE_TAGS, LICENSE_PACKAGES, LICENSE_SCOPES, LICENSE_PROHIBITED, LICENSE_RULES, normalizeLicense, normalizeLicenseProfile };
